class IllegalStateError extends Error {}

class IllegalArgumentError extends Error {}

class AuthError extends Error {}

class IOError extends Error {}

class IllegalEnvError extends Error {}

module.exports = { IllegalStateError, IllegalArgumentError, AuthError, IOError, IllegalEnvError };
